import { jsonReplaceDbActionVariables } from '../helpers/jsonReplaceVariables';
import { TpDashboardActionContext, TpDbActionStepDefinition as TpDbActionStepTypeDefinition } from '../interfaces';

function getJsonSchema(): any {
  return {
    type: 'object',
    title: 'Set Chart Config Param',
    description: 'Updates a chart config param.',
    properties: {
      type: { type: 'string', const: 'SetChartConfigParam' },
      chartId: {
        type: 'string',
        description: 'Identifier of the chart in the dashboard template to update.',
      },
      configParamId: {
        type: 'string',
        description: 'Identifier of the config param to update.',
      },
      value: {
        description: 'New value for the config param. You can refer to variables created earlier via "$VariableName"',
      },
    },
    required: ['type', 'chartId', 'configParamId'], // Do not require value as value could be falsy to unset a config param
  };
}

function execute(ctx: TpDashboardActionContext, step: any, onCompleted: () => void) {
  step = jsonReplaceDbActionVariables(ctx, step);

  const chartTemplateId = step.chartId;
  const chartDefs = ctx.dashboardContext.getChartDefsFromTemplateId(chartTemplateId);
  const chartIds = chartDefs.map((chartDef) => chartDef.id);

  chartIds.forEach((chartId) => {
    ctx.dashboardContext.updateChartConfigParam(chartId, step.configParamId, step.value);
  });
  onCompleted();
}

const dbActionStepSetChartConfigParam: TpDbActionStepTypeDefinition = {
  stepType: 'SetChartConfigParam',
  execute,
  getJsonSchema,
};

export default dbActionStepSetChartConfigParam;
